export const clickedBrandIcon =  {
    eventCategory: "homepage_dweb",
    event: "clicked_brand_icon",
    eventAction: "Brand selected"
};

export const viewAllBrandsOnSellHomePage = {
    event: "view_all_brands_on_sell_home_page",
    eventCategory: "Desktop_Sell_Flow",
    eventAction: "view all brands on sell home page"
};
